var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinisTextLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 26,
    viewBox: "0 0 149 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.3856C0 22.9169 3.07235 26 7.58781 26H27.2044V20.0568H8.8831V0H0V18.3856ZM117.147 0V5.9432H128.62V26H137.504V5.9432H148.977V0H117.147ZM84.7601 0V26H113.26V20.0568H93.6432V15.7859H112.52V10.2141H93.6432V5.9432H113.26V0H84.7601ZM71.6199 0V17.4571L57.2589 0H46.636V26H53.8537V8.54287L68.2147 26H78.8377V0H71.6199ZM31.8305 26H40.7136V0H31.8305V26Z",
    fill: "#E10600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinisTextLogo);
export default __webpack_public_path__ + "static/media/linis-text-logo.dc4917c8.svg";
export { ForwardRef as ReactComponent };